import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { TableController } from '../../../components/Constant'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { FEEDBACK_RATING_REPORTS, GET_VENDOR_LIST_FILTER } from '../../../repository/revenue_reports_repo'
import toast from 'react-hot-toast'
import moment from 'moment-timezone'

export const useReviewCommentsReport = () => {
    const { t } = useTranslation()
    const [controller, setController] = useState(TableController)
    const [loader, setLoader] = useState(false)
    const [totalCount, setTotalCount] = useState(0)
    const location = useLocation()
    const [details, setDetails] = useState([])
    const [otherInformation, setOtherInformation] = useState([])
    const [filter, setFilter] = useState({})
    const [vendorListData, setVendorListData] = useState([])

    const handlePagination = (obj) => setController(obj)

    const reportKey = useMemo(() => {
        const pathSegments = location.pathname.split('/').filter(Boolean)
        const lastSegment = pathSegments[pathSegments.length - 1]
        return lastSegment
    }, [location.pathname])

    const [filterInputs, setFilterInputs] = useState({
        startDate: null,
        endDate: null,
        vendor_id: null,
    })
    const filterRef = useRef(filterInputs)
    const getUserReport = useCallback(
        async (isDownload) => {
            setLoader(true)
            let payload = {
                type: reportKey,
                startDate: moment(filterRef?.current?.startDate).startOf('day'),
                endDate: moment(filterRef?.current?.endDate).endOf('day'),
                vendor_id: filterRef?.current?.vendor_id?._id,
                isDownloadExcel: isDownload,
                page: controller.page,
                count: controller.rowsPerPage,
            }
            try {
                let response = await FEEDBACK_RATING_REPORTS(payload)
                if (isDownload === false) {
                    setDetails(response?.data?.result)
                    setOtherInformation(response.otherInfo)
                    setTotalCount(response.totalCount)
                } else {
                    window.open(response?.data)
                }
                setLoader(false)
            } catch (error) {
                setDetails([])
                setLoader(false)
                toast.error(error.message)
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        },
        [controller, reportKey]
    )

    useEffect(() => {
        filterRef.current = filterInputs
    }, [filterInputs])

    const getVendorList = useCallback(async () => {
        setLoader(true)
        const payload = { count: 1000 }
        try {
            let response = await GET_VENDOR_LIST_FILTER(payload)
            setVendorListData(response?.data?.map((cur) => ({ ...cur, fullName: `${cur?.firstName}  ${cur?.lastName}` })))
            setLoader(false)
        } catch (error) {
            toast.error(error.message)
            setVendorListData([])
            setLoader(false)
        }
    }, [])

    useEffect(() => {
        getUserReport(false)
        getVendorList()
    }, [getUserReport, getVendorList])

    const reviewAndCommentsTableHead = [
        { label: '#' },
        { label: `${t('formTitle.client')}` },
        { label: `${t('tableTitle.vendorName')}` },
        { label: `${t('tableTitle.starRating')} / ${t('tableTitle.date')}` },
        { label: `${t('filterTitle.status')}` },
        { label: `${t('tableTitle.feedback')}` },
    ]

    const averageRatingTableHead = [{ label: '#' }, { label: `${t('tableTitle.vendorName')}` }, { label: `${t('filterTitle.rating')}` }, { label: `${t('tableTitle.feedback')}` }]

    const handleFilterInputChange = (name, value) => {
        setFilterInputs((prev) => ({
            ...prev,
            [name]: name !== 'vendor_id' ? value : value[0],
        }))
    }

    const reset = () => {
        const cleared = { startDate: null, endDate: null, vendor_id: null }
        setFilterInputs(cleared)
        filterRef.current = cleared
        getUserReport(false)
    }

    const search = () => getUserReport(false)

    return {
        data: {
            controller,
            loader,
            totalCount,
            details,
            filter,
            otherInformation,
            filterInputs,
            vendorListData,
            reviewAndCommentsTableHead,
            averageRatingTableHead,
        },
        methods: { handlePagination, setLoader, setTotalCount, setFilter, handleFilterInputChange, reset, search, getUserReport },
    }
}
